export const APP_STORE_REVIEW_COOKIE_NAME = 'x-launch-type-v2';
export const APP_STORE_REVIEW_COOKIE_VALUE = 'native';

export const APP_STORE_REVIEW_HEADER_NAME = 'x-launch-type';
export const APP_STORE_REVIEW_HEADER_VALUE = APP_STORE_REVIEW_COOKIE_VALUE;
